<div id="desktop-startpage">
    <div class="left column"></div>
    <div class="center column"></div>
    <div class="right column"></div>
</div>